// AUTO-GENERATED by scripts/build-qa-catalog.mjs. DO NOT EDIT BY HAND.
// Regenerate with `pnpm --filter @pc/web run qa:catalog` (also runs on build/dev).
// Source: docs/qa/{modules,integrations,edge-functions,cross-cutting}/*.md

export type QaSurfaceKind = 'modules' | 'integrations' | 'edge-functions' | 'cross-cutting';
export type QaSurfaceStatus = 'red' | 'yellow' | 'green' | 'archived';

export interface QaCatalogEntry {
  slug: string;
  kind: QaSurfaceKind;
  status: QaSurfaceStatus;
  title: string;
  /** Checklist frontmatter last_reset_at (YYYY-MM-DD), or null. */
  lastResetAt: string | null;
  /** Optional verify route declared in checklist frontmatter (verify_route:). */
  verifyRoute: string | null;
  /** Optional verify hint declared in checklist frontmatter (verify_hint:). */
  verifyHint: string | null;
  totalItems: number;
  uncheckedAgent: number;
  uncheckedOperator: number;
}

export const QA_CATALOG: QaCatalogEntry[] = [
  {
    "slug": "ad-attribution-and-pacing",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Ad attribution and pacing — cross-cutting verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 19,
    "uncheckedAgent": 11,
    "uncheckedOperator": 8
  },
  {
    "slug": "admin-order-review",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Platform-admin per-PO/order review verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 43,
    "uncheckedAgent": 5,
    "uncheckedOperator": 20
  },
  {
    "slug": "analytics-pageviews",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Analytics pageviews — cross-cutting verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 28,
    "uncheckedAgent": 2,
    "uncheckedOperator": 4
  },
  {
    "slug": "audit-chain-and-redaction",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Audit chain isolation and redaction verification",
    "lastResetAt": "2026-06-05",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 18,
    "uncheckedAgent": 5,
    "uncheckedOperator": 6
  },
  {
    "slug": "audit-hash-chain",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Audit hash chain verification",
    "lastResetAt": "2026-05-23",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 38,
    "uncheckedAgent": 16,
    "uncheckedOperator": 7
  },
  {
    "slug": "auth-and-mfa",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Auth and MFA verification",
    "lastResetAt": "2026-06-11",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 86,
    "uncheckedAgent": 8,
    "uncheckedOperator": 67
  },
  {
    "slug": "billing-gate-and-quotas",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Billing gate and quotas verification",
    "lastResetAt": "2026-07-02",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 50,
    "uncheckedAgent": 16,
    "uncheckedOperator": 26
  },
  {
    "slug": "buyer-cart-and-checkout",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Buyer cart + checkout + address book verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 28,
    "uncheckedAgent": 7,
    "uncheckedOperator": 19
  },
  {
    "slug": "careers",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Careers (job board + application inbox) verification",
    "lastResetAt": "2026-05-21",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 33,
    "uncheckedAgent": 1,
    "uncheckedOperator": 24
  },
  {
    "slug": "cash-register",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Cash register verification",
    "lastResetAt": "2026-05-23",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 17,
    "uncheckedAgent": 5,
    "uncheckedOperator": 6
  },
  {
    "slug": "dev-mode",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Dev Mode (platform-admin feature verification) verification",
    "lastResetAt": "2026-06-03",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 14,
    "uncheckedAgent": 3,
    "uncheckedOperator": 8
  },
  {
    "slug": "docs-site-guides",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Docs site guides verification",
    "lastResetAt": "2026-05-21",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 16,
    "uncheckedAgent": 11,
    "uncheckedOperator": 5
  },
  {
    "slug": "e2e-coverage",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "End-to-end (Playwright) coverage verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 17,
    "uncheckedAgent": 7,
    "uncheckedOperator": 10
  },
  {
    "slug": "email-delivery-pipeline",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Email delivery pipeline verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 26,
    "uncheckedAgent": 14,
    "uncheckedOperator": 10
  },
  {
    "slug": "error-ingestion-and-reporting",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Error ingestion and reporting verification",
    "lastResetAt": "2026-06-09",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 19,
    "uncheckedAgent": 10,
    "uncheckedOperator": 9
  },
  {
    "slug": "external-order-ingest",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "External order ingest verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 18,
    "uncheckedAgent": 5,
    "uncheckedOperator": 4
  },
  {
    "slug": "global-search",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Universal global search verification",
    "lastResetAt": "2026-06-09",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 9,
    "uncheckedAgent": 1,
    "uncheckedOperator": 3
  },
  {
    "slug": "help-messaging",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Help messaging (vendor ↔ admin, buyer ↔ admin) verification",
    "lastResetAt": "2026-05-21",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 26,
    "uncheckedAgent": 0,
    "uncheckedOperator": 11
  },
  {
    "slug": "i18n",
    "kind": "cross-cutting",
    "status": "red",
    "title": "i18n + AI translation verification",
    "lastResetAt": "2026-05-25",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 47,
    "uncheckedAgent": 17,
    "uncheckedOperator": 7
  },
  {
    "slug": "integration-resolution",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Integration resolution verification",
    "lastResetAt": "2026-06-09",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 12,
    "uncheckedAgent": 7,
    "uncheckedOperator": 5
  },
  {
    "slug": "legal-pages",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Legal pages verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 21,
    "uncheckedAgent": 4,
    "uncheckedOperator": 5
  },
  {
    "slug": "multi-store-isolation",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Multi-store / multi-org isolation verification",
    "lastResetAt": "2026-06-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 30,
    "uncheckedAgent": 17,
    "uncheckedOperator": 2
  },
  {
    "slug": "native-webhook-adapters",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Native webhook adapters verification",
    "lastResetAt": "2026-05-21",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 11,
    "uncheckedAgent": 5,
    "uncheckedOperator": 0
  },
  {
    "slug": "nav-pins",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Navigation pins verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 14,
    "uncheckedAgent": 4,
    "uncheckedOperator": 7
  },
  {
    "slug": "officehub-migration",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "OfficeHub -> MSBR migration verification",
    "lastResetAt": "2026-06-08",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 98,
    "uncheckedAgent": 13,
    "uncheckedOperator": 9
  },
  {
    "slug": "operator-extensibility",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Operator self-service extensibility",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 24,
    "uncheckedAgent": 4,
    "uncheckedOperator": 5
  },
  {
    "slug": "org-mode-shell",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Enter-organization mode verification",
    "lastResetAt": "2026-06-11",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 46,
    "uncheckedAgent": 4,
    "uncheckedOperator": 34
  },
  {
    "slug": "org-pii-anonymization",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Org PII anonymization verification",
    "lastResetAt": "2026-06-08",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 17,
    "uncheckedAgent": 11,
    "uncheckedOperator": 3
  },
  {
    "slug": "pagination-and-virtual-list",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Pagination and VirtualList verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 17,
    "uncheckedAgent": 12,
    "uncheckedOperator": 5
  },
  {
    "slug": "partner-commission-ledger",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Partner commission ledger verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 23,
    "uncheckedAgent": 12,
    "uncheckedOperator": 5
  },
  {
    "slug": "pdf-print-templates",
    "kind": "cross-cutting",
    "status": "red",
    "title": "PDF print templates verification",
    "lastResetAt": "2026-05-25",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 13,
    "uncheckedAgent": 3,
    "uncheckedOperator": 7
  },
  {
    "slug": "product-form-taxonomy",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Product form taxonomy verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 46,
    "uncheckedAgent": 4,
    "uncheckedOperator": 28
  },
  {
    "slug": "product-translations",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Product translations (entity_type=shop.product) verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 9,
    "uncheckedAgent": 3,
    "uncheckedOperator": 3
  },
  {
    "slug": "product-trending-pipeline",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Product trending pipeline verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 12,
    "uncheckedAgent": 2,
    "uncheckedOperator": 5
  },
  {
    "slug": "qa-observed-checks",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "QA observed-check subsystem verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 18,
    "uncheckedAgent": 3,
    "uncheckedOperator": 5
  },
  {
    "slug": "research-use-attestation",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Research-use-only (RUO) attestation gate verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 17,
    "uncheckedAgent": 9,
    "uncheckedOperator": 8
  },
  {
    "slug": "returns-and-rma",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Buyer-initiated returns / RMA verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 32,
    "uncheckedAgent": 11,
    "uncheckedOperator": 21
  },
  {
    "slug": "screen-lock",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Universal screen lock verification",
    "lastResetAt": "2026-06-09",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 20,
    "uncheckedAgent": 0,
    "uncheckedOperator": 12
  },
  {
    "slug": "sms-delivery-pipeline",
    "kind": "cross-cutting",
    "status": "red",
    "title": "SMS delivery pipeline verification",
    "lastResetAt": "2026-07-02",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 24,
    "uncheckedAgent": 13,
    "uncheckedOperator": 8
  },
  {
    "slug": "spa-deploy-resilience",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "SPA deploy resilience verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 26,
    "uncheckedAgent": 0,
    "uncheckedOperator": 4
  },
  {
    "slug": "store-archive-lifecycle",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Store archive lifecycle verification",
    "lastResetAt": "2026-06-08",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 39,
    "uncheckedAgent": 15,
    "uncheckedOperator": 19
  },
  {
    "slug": "store-template-overrides",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Per-store template overrides verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 27,
    "uncheckedAgent": 11,
    "uncheckedOperator": 6
  },
  {
    "slug": "vendor-broadcasts",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Vendor broadcasts verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 30,
    "uncheckedAgent": 8,
    "uncheckedOperator": 15
  },
  {
    "slug": "vendor-claim-flow",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Vendor pre-provisioning + claim flow verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 36,
    "uncheckedAgent": 4,
    "uncheckedOperator": 14
  },
  {
    "slug": "vendor-follower-notifications",
    "kind": "cross-cutting",
    "status": "green",
    "title": "Vendor follower notifications verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 30,
    "uncheckedAgent": 0,
    "uncheckedOperator": 4
  },
  {
    "slug": "vendor-public-storefront",
    "kind": "cross-cutting",
    "status": "red",
    "title": "Vendor public storefront verification",
    "lastResetAt": "2026-06-08",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 62,
    "uncheckedAgent": 14,
    "uncheckedOperator": 32
  },
  {
    "slug": "vendor-suspension-lockdown",
    "kind": "cross-cutting",
    "status": "yellow",
    "title": "Vendor-suspension lockdown verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 22,
    "uncheckedAgent": 0,
    "uncheckedOperator": 10
  },
  {
    "slug": "accept-invite",
    "kind": "edge-functions",
    "status": "red",
    "title": "accept-invite edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 15,
    "uncheckedAgent": 10,
    "uncheckedOperator": 5
  },
  {
    "slug": "admin-lead-reply",
    "kind": "edge-functions",
    "status": "red",
    "title": "admin-lead-reply edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 13,
    "uncheckedAgent": 9,
    "uncheckedOperator": 4
  },
  {
    "slug": "admin-sms",
    "kind": "edge-functions",
    "status": "red",
    "title": "admin-sms edge function verification",
    "lastResetAt": "2026-05-26",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 16,
    "uncheckedAgent": 10,
    "uncheckedOperator": 4
  },
  {
    "slug": "audit-archive-cron",
    "kind": "edge-functions",
    "status": "red",
    "title": "audit-archive-cron edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 13,
    "uncheckedAgent": 11,
    "uncheckedOperator": 2
  },
  {
    "slug": "auth-audit-hook",
    "kind": "edge-functions",
    "status": "red",
    "title": "auth-audit-hook edge function verification",
    "lastResetAt": "2026-06-03",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 17,
    "uncheckedAgent": 7,
    "uncheckedOperator": 6
  },
  {
    "slug": "auth-email-hook",
    "kind": "edge-functions",
    "status": "red",
    "title": "auth-email-hook edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 15,
    "uncheckedAgent": 9,
    "uncheckedOperator": 6
  },
  {
    "slug": "billing-notifications-cron",
    "kind": "edge-functions",
    "status": "red",
    "title": "billing-notifications-cron edge function verification",
    "lastResetAt": "2026-06-06",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 20,
    "uncheckedAgent": 6,
    "uncheckedOperator": 8
  },
  {
    "slug": "calendar-action-public",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "calendar-action-public edge function verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 24,
    "uncheckedAgent": 8,
    "uncheckedOperator": 7
  },
  {
    "slug": "calendar-feed",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "calendar-feed edge function verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 17,
    "uncheckedAgent": 7,
    "uncheckedOperator": 4
  },
  {
    "slug": "calendar-notify",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "calendar-notify edge function verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 24,
    "uncheckedAgent": 11,
    "uncheckedOperator": 6
  },
  {
    "slug": "dispatch-webhook",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "dispatch-webhook edge function verification",
    "lastResetAt": "2026-05-19",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 22,
    "uncheckedAgent": 4,
    "uncheckedOperator": 8
  },
  {
    "slug": "email-queue-flush",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "email-queue-flush edge function verification",
    "lastResetAt": "2026-05-26",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 21,
    "uncheckedAgent": 8,
    "uncheckedOperator": 1
  },
  {
    "slug": "errors-ingest",
    "kind": "edge-functions",
    "status": "red",
    "title": "errors-ingest edge function verification",
    "lastResetAt": "2026-06-09",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 17,
    "uncheckedAgent": 12,
    "uncheckedOperator": 3
  },
  {
    "slug": "fulfillment-notify",
    "kind": "edge-functions",
    "status": "red",
    "title": "fulfillment-notify edge function verification",
    "lastResetAt": "2026-06-11",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 28,
    "uncheckedAgent": 15,
    "uncheckedOperator": 6
  },
  {
    "slug": "fulfillment-track-public",
    "kind": "edge-functions",
    "status": "red",
    "title": "fulfillment-track-public edge function verification",
    "lastResetAt": "2026-06-09",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 23,
    "uncheckedAgent": 14,
    "uncheckedOperator": 3
  },
  {
    "slug": "fulfillment-track-reconcile",
    "kind": "edge-functions",
    "status": "red",
    "title": "fulfillment-track-reconcile edge function verification",
    "lastResetAt": "2026-06-11",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 22,
    "uncheckedAgent": 12,
    "uncheckedOperator": 3
  },
  {
    "slug": "fulfillment-track-webhook",
    "kind": "edge-functions",
    "status": "red",
    "title": "fulfillment-track-webhook edge function verification",
    "lastResetAt": "2026-06-11",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 22,
    "uncheckedAgent": 13,
    "uncheckedOperator": 5
  },
  {
    "slug": "im-notify",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "im-notify edge function verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 13,
    "uncheckedAgent": 7,
    "uncheckedOperator": 1
  },
  {
    "slug": "integration-api",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "integration-api edge function verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 25,
    "uncheckedAgent": 8,
    "uncheckedOperator": 2
  },
  {
    "slug": "notify-proposal",
    "kind": "edge-functions",
    "status": "red",
    "title": "notify-proposal edge function verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 18,
    "uncheckedAgent": 12,
    "uncheckedOperator": 6
  },
  {
    "slug": "partners-admin-invite-partner",
    "kind": "edge-functions",
    "status": "red",
    "title": "partners-admin-invite-partner edge function verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 28,
    "uncheckedAgent": 11,
    "uncheckedOperator": 7
  },
  {
    "slug": "partners-connect-sync",
    "kind": "edge-functions",
    "status": "red",
    "title": "partners-connect-sync edge function verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 23,
    "uncheckedAgent": 14,
    "uncheckedOperator": 3
  },
  {
    "slug": "partners-pair-lookup",
    "kind": "edge-functions",
    "status": "red",
    "title": "partners-pair-lookup edge function verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 17,
    "uncheckedAgent": 8,
    "uncheckedOperator": 2
  },
  {
    "slug": "partners-pair-redeem",
    "kind": "edge-functions",
    "status": "red",
    "title": "partners-pair-redeem edge function verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 18,
    "uncheckedAgent": 11,
    "uncheckedOperator": 3
  },
  {
    "slug": "price-sheet-extract",
    "kind": "edge-functions",
    "status": "red",
    "title": "price-sheet-extract edge function verification",
    "lastResetAt": "2026-05-24",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 28,
    "uncheckedAgent": 20,
    "uncheckedOperator": 2
  },
  {
    "slug": "provider-verify",
    "kind": "edge-functions",
    "status": "red",
    "title": "provider-verify edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 15,
    "uncheckedAgent": 9,
    "uncheckedOperator": 6
  },
  {
    "slug": "public-api",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "public-api edge function verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 27,
    "uncheckedAgent": 15,
    "uncheckedOperator": 2
  },
  {
    "slug": "public-leads",
    "kind": "edge-functions",
    "status": "red",
    "title": "public-leads edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 13,
    "uncheckedAgent": 9,
    "uncheckedOperator": 4
  },
  {
    "slug": "public-marketplace",
    "kind": "edge-functions",
    "status": "red",
    "title": "public-marketplace edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 10,
    "uncheckedAgent": 6,
    "uncheckedOperator": 4
  },
  {
    "slug": "public-module-requests",
    "kind": "edge-functions",
    "status": "red",
    "title": "public-module-requests edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 13,
    "uncheckedAgent": 8,
    "uncheckedOperator": 5
  },
  {
    "slug": "public-pricing",
    "kind": "edge-functions",
    "status": "red",
    "title": "public-pricing edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 10,
    "uncheckedAgent": 7,
    "uncheckedOperator": 3
  },
  {
    "slug": "public-storefront",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "public-storefront edge function verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 29,
    "uncheckedAgent": 0,
    "uncheckedOperator": 7
  },
  {
    "slug": "public-storefront-page",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "public-storefront-page edge function verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 22,
    "uncheckedAgent": 0,
    "uncheckedOperator": 4
  },
  {
    "slug": "record-ruo-attestation",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "record-ruo-attestation edge function verification",
    "lastResetAt": "2026-05-19",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 21,
    "uncheckedAgent": 0,
    "uncheckedOperator": 4
  },
  {
    "slug": "resend-webhook",
    "kind": "edge-functions",
    "status": "red",
    "title": "resend-webhook edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 15,
    "uncheckedAgent": 10,
    "uncheckedOperator": 5
  },
  {
    "slug": "send-email",
    "kind": "edge-functions",
    "status": "red",
    "title": "send-email edge function verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 16,
    "uncheckedAgent": 13,
    "uncheckedOperator": 3
  },
  {
    "slug": "send-sms",
    "kind": "edge-functions",
    "status": "red",
    "title": "send-sms edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 14,
    "uncheckedAgent": 11,
    "uncheckedOperator": 3
  },
  {
    "slug": "sendblue-webhook",
    "kind": "edge-functions",
    "status": "red",
    "title": "sendblue-webhook edge function verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 16,
    "uncheckedAgent": 10,
    "uncheckedOperator": 4
  },
  {
    "slug": "shipping-label",
    "kind": "edge-functions",
    "status": "red",
    "title": "shipping-label edge function verification",
    "lastResetAt": "2026-06-11",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 18,
    "uncheckedAgent": 11,
    "uncheckedOperator": 6
  },
  {
    "slug": "shop-ad-checkout",
    "kind": "edge-functions",
    "status": "archived",
    "title": "shop-ad-checkout edge function verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 13,
    "uncheckedAgent": 9,
    "uncheckedOperator": 4
  },
  {
    "slug": "shop-ad-checkout-topup",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "shop-ad-checkout-topup edge function verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 20,
    "uncheckedAgent": 13,
    "uncheckedOperator": 4
  },
  {
    "slug": "shop-ad-conversion",
    "kind": "edge-functions",
    "status": "red",
    "title": "shop-ad-conversion edge function verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 24,
    "uncheckedAgent": 22,
    "uncheckedOperator": 2
  },
  {
    "slug": "shop-ad-event",
    "kind": "edge-functions",
    "status": "red",
    "title": "shop-ad-event edge function verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 26,
    "uncheckedAgent": 23,
    "uncheckedOperator": 1
  },
  {
    "slug": "shop-ad-stripe-webhook",
    "kind": "edge-functions",
    "status": "red",
    "title": "shop-ad-stripe-webhook edge function verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 18,
    "uncheckedAgent": 16,
    "uncheckedOperator": 2
  },
  {
    "slug": "shop-message-send",
    "kind": "edge-functions",
    "status": "red",
    "title": "shop-message-send edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 14,
    "uncheckedAgent": 10,
    "uncheckedOperator": 4
  },
  {
    "slug": "shop-notify",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "shop-notify edge function verification",
    "lastResetAt": "2026-05-21",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 28,
    "uncheckedAgent": 7,
    "uncheckedOperator": 7
  },
  {
    "slug": "shop-public-catalog",
    "kind": "edge-functions",
    "status": "red",
    "title": "shop-public-catalog edge function verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 12,
    "uncheckedAgent": 9,
    "uncheckedOperator": 3
  },
  {
    "slug": "shop-shippo-track",
    "kind": "edge-functions",
    "status": "red",
    "title": "shop-shippo-track edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 15,
    "uncheckedAgent": 11,
    "uncheckedOperator": 4
  },
  {
    "slug": "shop-storage-sign",
    "kind": "edge-functions",
    "status": "red",
    "title": "shop-storage-sign edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 20,
    "uncheckedAgent": 15,
    "uncheckedOperator": 5
  },
  {
    "slug": "shop-stripe-portal",
    "kind": "edge-functions",
    "status": "red",
    "title": "shop-stripe-portal edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 10,
    "uncheckedAgent": 7,
    "uncheckedOperator": 3
  },
  {
    "slug": "shop-unread-reminder-cron",
    "kind": "edge-functions",
    "status": "red",
    "title": "shop-unread-reminder-cron edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 9,
    "uncheckedAgent": 7,
    "uncheckedOperator": 2
  },
  {
    "slug": "shop-vendor-claim",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "shop-vendor-claim edge function verification",
    "lastResetAt": "2026-05-20",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 24,
    "uncheckedAgent": 15,
    "uncheckedOperator": 4
  },
  {
    "slug": "shop-vendor-signup",
    "kind": "edge-functions",
    "status": "red",
    "title": "shop-vendor-signup edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 14,
    "uncheckedAgent": 9,
    "uncheckedOperator": 5
  },
  {
    "slug": "sms-flush-queue",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "sms-flush-queue edge function verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 17,
    "uncheckedAgent": 5,
    "uncheckedOperator": 2
  },
  {
    "slug": "status-notify-cron",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "status-notify-cron edge function verification",
    "lastResetAt": "2026-05-21",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 31,
    "uncheckedAgent": 7,
    "uncheckedOperator": 8
  },
  {
    "slug": "status-probe",
    "kind": "edge-functions",
    "status": "red",
    "title": "status-probe edge function verification",
    "lastResetAt": "2026-05-25",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 20,
    "uncheckedAgent": 3,
    "uncheckedOperator": 7
  },
  {
    "slug": "store-archive-tick",
    "kind": "edge-functions",
    "status": "red",
    "title": "store-archive-tick edge function verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 18,
    "uncheckedAgent": 10,
    "uncheckedOperator": 4
  },
  {
    "slug": "stripe-billing-admin",
    "kind": "edge-functions",
    "status": "red",
    "title": "stripe-billing-admin edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 13,
    "uncheckedAgent": 9,
    "uncheckedOperator": 4
  },
  {
    "slug": "stripe-billing-checkout",
    "kind": "edge-functions",
    "status": "red",
    "title": "stripe-billing-checkout edge function verification",
    "lastResetAt": "2026-05-21",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 23,
    "uncheckedAgent": 12,
    "uncheckedOperator": 9
  },
  {
    "slug": "stripe-billing-portal",
    "kind": "edge-functions",
    "status": "red",
    "title": "stripe-billing-portal edge function verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 11,
    "uncheckedAgent": 7,
    "uncheckedOperator": 4
  },
  {
    "slug": "stripe-billing-webhook",
    "kind": "edge-functions",
    "status": "red",
    "title": "stripe-billing-webhook edge function verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 16,
    "uncheckedAgent": 10,
    "uncheckedOperator": 5
  },
  {
    "slug": "track-pageview",
    "kind": "edge-functions",
    "status": "yellow",
    "title": "track-pageview edge function verification",
    "lastResetAt": "2026-05-19",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 22,
    "uncheckedAgent": 2,
    "uncheckedOperator": 2
  },
  {
    "slug": "user-sms-auth",
    "kind": "edge-functions",
    "status": "red",
    "title": "user-sms-auth edge function verification",
    "lastResetAt": "2026-05-24",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 32,
    "uncheckedAgent": 9,
    "uncheckedOperator": 18
  },
  {
    "slug": "vendor-price-list-pdf",
    "kind": "edge-functions",
    "status": "red",
    "title": "vendor-price-list-pdf edge function verification",
    "lastResetAt": "2026-05-21",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 37,
    "uncheckedAgent": 11,
    "uncheckedOperator": 10
  },
  {
    "slug": "wholesaler-price-list-pdf",
    "kind": "edge-functions",
    "status": "red",
    "title": "wholesaler-price-list-pdf edge function verification",
    "lastResetAt": "2026-05-23",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 18,
    "uncheckedAgent": 11,
    "uncheckedOperator": 3
  },
  {
    "slug": "wholesalers-admin-invite",
    "kind": "edge-functions",
    "status": "red",
    "title": "wholesalers-admin-invite edge function verification",
    "lastResetAt": "2026-05-23",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 22,
    "uncheckedAgent": 17,
    "uncheckedOperator": 2
  },
  {
    "slug": "clover",
    "kind": "integrations",
    "status": "archived",
    "title": "Clover integration verification (stub)",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 0,
    "uncheckedAgent": 0,
    "uncheckedOperator": 0
  },
  {
    "slug": "dialpad",
    "kind": "integrations",
    "status": "archived",
    "title": "Dialpad integration verification (stub)",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 0,
    "uncheckedAgent": 0,
    "uncheckedOperator": 0
  },
  {
    "slug": "easypost",
    "kind": "integrations",
    "status": "archived",
    "title": "EasyPost integration verification (stub)",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 0,
    "uncheckedAgent": 0,
    "uncheckedOperator": 0
  },
  {
    "slug": "openai-extraction",
    "kind": "integrations",
    "status": "red",
    "title": "OpenAI extraction integration verification",
    "lastResetAt": "2026-05-21",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 20,
    "uncheckedAgent": 12,
    "uncheckedOperator": 4
  },
  {
    "slug": "pirateship",
    "kind": "integrations",
    "status": "archived",
    "title": "PirateShip integration verification (stub)",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 0,
    "uncheckedAgent": 0,
    "uncheckedOperator": 0
  },
  {
    "slug": "resend",
    "kind": "integrations",
    "status": "red",
    "title": "Resend integration verification",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 29,
    "uncheckedAgent": 12,
    "uncheckedOperator": 17
  },
  {
    "slug": "sendblue",
    "kind": "integrations",
    "status": "red",
    "title": "Sendblue integration verification",
    "lastResetAt": "2026-07-02",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 28,
    "uncheckedAgent": 12,
    "uncheckedOperator": 16
  },
  {
    "slug": "sendblue-subaccounts",
    "kind": "integrations",
    "status": "red",
    "title": "Sendblue subaccounts (managed agency tier) verification",
    "lastResetAt": "2026-06-09",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 42,
    "uncheckedAgent": 14,
    "uncheckedOperator": 17
  },
  {
    "slug": "shippo",
    "kind": "integrations",
    "status": "red",
    "title": "Shippo integration verification",
    "lastResetAt": "2026-06-09",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 25,
    "uncheckedAgent": 10,
    "uncheckedOperator": 15
  },
  {
    "slug": "square",
    "kind": "integrations",
    "status": "archived",
    "title": "Square integration verification (stub)",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 0,
    "uncheckedAgent": 0,
    "uncheckedOperator": 0
  },
  {
    "slug": "stripe",
    "kind": "integrations",
    "status": "red",
    "title": "Stripe integration verification",
    "lastResetAt": "2026-05-23",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 30,
    "uncheckedAgent": 10,
    "uncheckedOperator": 20
  },
  {
    "slug": "stripe-connect",
    "kind": "integrations",
    "status": "red",
    "title": "Stripe Connect Express integration verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 41,
    "uncheckedAgent": 20,
    "uncheckedOperator": 17
  },
  {
    "slug": "twilio",
    "kind": "integrations",
    "status": "archived",
    "title": "Twilio integration verification (stub)",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 0,
    "uncheckedAgent": 0,
    "uncheckedOperator": 0
  },
  {
    "slug": "ups",
    "kind": "integrations",
    "status": "archived",
    "title": "UPS integration verification (stub)",
    "lastResetAt": "2026-05-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 0,
    "uncheckedAgent": 0,
    "uncheckedOperator": 0
  },
  {
    "slug": "admin-price-sheet-import",
    "kind": "modules",
    "status": "red",
    "title": "Admin price-sheet import module verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 27,
    "uncheckedAgent": 7,
    "uncheckedOperator": 16
  },
  {
    "slug": "auth-app",
    "kind": "modules",
    "status": "red",
    "title": "Central auth site (auth.peptideclients.com) verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 69,
    "uncheckedAgent": 10,
    "uncheckedOperator": 32
  },
  {
    "slug": "calendar",
    "kind": "modules",
    "status": "red",
    "title": "Calendar module verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 113,
    "uncheckedAgent": 67,
    "uncheckedOperator": 46
  },
  {
    "slug": "clients",
    "kind": "modules",
    "status": "red",
    "title": "Clients module verification",
    "lastResetAt": "2026-06-09",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 29,
    "uncheckedAgent": 9,
    "uncheckedOperator": 17
  },
  {
    "slug": "clients-inbox",
    "kind": "modules",
    "status": "red",
    "title": "Clients Inbox module verification",
    "lastResetAt": "2026-05-26",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 58,
    "uncheckedAgent": 13,
    "uncheckedOperator": 31
  },
  {
    "slug": "contracts",
    "kind": "modules",
    "status": "red",
    "title": "Contracts module verification",
    "lastResetAt": "2026-06-11",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 23,
    "uncheckedAgent": 10,
    "uncheckedOperator": 13
  },
  {
    "slug": "credits",
    "kind": "modules",
    "status": "red",
    "title": "Credits module verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 15,
    "uncheckedAgent": 10,
    "uncheckedOperator": 1
  },
  {
    "slug": "fulfillment",
    "kind": "modules",
    "status": "red",
    "title": "Fulfillment module verification",
    "lastResetAt": "2026-06-11",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 82,
    "uncheckedAgent": 17,
    "uncheckedOperator": 36
  },
  {
    "slug": "inventory",
    "kind": "modules",
    "status": "red",
    "title": "Inventory module verification",
    "lastResetAt": "2026-05-23",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 22,
    "uncheckedAgent": 7,
    "uncheckedOperator": 9
  },
  {
    "slug": "legal",
    "kind": "modules",
    "status": "red",
    "title": "Legal module verification",
    "lastResetAt": "2026-05-23",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 33,
    "uncheckedAgent": 5,
    "uncheckedOperator": 14
  },
  {
    "slug": "lot-management",
    "kind": "modules",
    "status": "yellow",
    "title": "Lot Management module verification",
    "lastResetAt": "2026-06-18",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 31,
    "uncheckedAgent": 1,
    "uncheckedOperator": 22
  },
  {
    "slug": "marketing",
    "kind": "modules",
    "status": "red",
    "title": "Marketing module verification",
    "lastResetAt": "2026-05-31",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 18,
    "uncheckedAgent": 7,
    "uncheckedOperator": 6
  },
  {
    "slug": "messaging",
    "kind": "modules",
    "status": "yellow",
    "title": "Messaging (internal IM) module verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 34,
    "uncheckedAgent": 6,
    "uncheckedOperator": 14
  },
  {
    "slug": "messaging-lines",
    "kind": "modules",
    "status": "red",
    "title": "Messaging lines module verification",
    "lastResetAt": "2026-07-02",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 43,
    "uncheckedAgent": 22,
    "uncheckedOperator": 19
  },
  {
    "slug": "orders",
    "kind": "modules",
    "status": "red",
    "title": "Orders module verification",
    "lastResetAt": "2026-06-11",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 89,
    "uncheckedAgent": 14,
    "uncheckedOperator": 62
  },
  {
    "slug": "partners",
    "kind": "modules",
    "status": "red",
    "title": "Partners (affiliate / cold-caller) module verification",
    "lastResetAt": "2026-05-26",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 44,
    "uncheckedAgent": 17,
    "uncheckedOperator": 17
  },
  {
    "slug": "pricing",
    "kind": "modules",
    "status": "red",
    "title": "Pricing module verification",
    "lastResetAt": "2026-05-23",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 21,
    "uncheckedAgent": 11,
    "uncheckedOperator": 1
  },
  {
    "slug": "products",
    "kind": "modules",
    "status": "red",
    "title": "Products module verification",
    "lastResetAt": "2026-05-25",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 30,
    "uncheckedAgent": 9,
    "uncheckedOperator": 17
  },
  {
    "slug": "referrals",
    "kind": "modules",
    "status": "red",
    "title": "Referrals module verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 13,
    "uncheckedAgent": 9,
    "uncheckedOperator": 1
  },
  {
    "slug": "reports",
    "kind": "modules",
    "status": "red",
    "title": "Reports module verification",
    "lastResetAt": "2026-05-25",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 62,
    "uncheckedAgent": 9,
    "uncheckedOperator": 28
  },
  {
    "slug": "rewards",
    "kind": "modules",
    "status": "red",
    "title": "Rewards module verification",
    "lastResetAt": "2026-06-09",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 25,
    "uncheckedAgent": 11,
    "uncheckedOperator": 13
  },
  {
    "slug": "settings-search",
    "kind": "modules",
    "status": "red",
    "title": "Settings search verification",
    "lastResetAt": "2026-06-08",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 16,
    "uncheckedAgent": 6,
    "uncheckedOperator": 10
  },
  {
    "slug": "shipping",
    "kind": "modules",
    "status": "red",
    "title": "Shipping module verification",
    "lastResetAt": "2026-06-11",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 37,
    "uncheckedAgent": 12,
    "uncheckedOperator": 22
  },
  {
    "slug": "shop",
    "kind": "modules",
    "status": "red",
    "title": "Shop module verification",
    "lastResetAt": "2026-06-08",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 139,
    "uncheckedAgent": 36,
    "uncheckedOperator": 72
  },
  {
    "slug": "shop-advertising",
    "kind": "modules",
    "status": "red",
    "title": "Shop advertising module verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 34,
    "uncheckedAgent": 13,
    "uncheckedOperator": 21
  },
  {
    "slug": "shop-vendor-payment-methods",
    "kind": "modules",
    "status": "yellow",
    "title": "Vendor payment methods module verification",
    "lastResetAt": "2026-05-21",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 58,
    "uncheckedAgent": 14,
    "uncheckedOperator": 40
  },
  {
    "slug": "shop-vendor-profile-completion",
    "kind": "modules",
    "status": "yellow",
    "title": "Shop vendor profile completion verification",
    "lastResetAt": "2026-05-24",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 38,
    "uncheckedAgent": 7,
    "uncheckedOperator": 15
  },
  {
    "slug": "vendors",
    "kind": "modules",
    "status": "red",
    "title": "Vendors module verification",
    "lastResetAt": "2026-05-22",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 22,
    "uncheckedAgent": 9,
    "uncheckedOperator": 13
  },
  {
    "slug": "wholesaler-portal",
    "kind": "modules",
    "status": "red",
    "title": "Wholesaler portal verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 52,
    "uncheckedAgent": 21,
    "uncheckedOperator": 30
  },
  {
    "slug": "wholesalers",
    "kind": "modules",
    "status": "red",
    "title": "Wholesalers module verification",
    "lastResetAt": "2026-06-10",
    "verifyRoute": null,
    "verifyHint": null,
    "totalItems": 53,
    "uncheckedAgent": 18,
    "uncheckedOperator": 35
  }
];
